import * as React from 'react';
import Text from './Text';
import { InputProps } from './Input';
import { customerNameRegexErrorMessage, customerNameRegexString } from '../../../core/domain';

/**
 * A customer facing name (Customer Name / Public Display Name).
 *
 * The pattern, message and length belong together: the regex excludes the markup characters that let HTML and
 * script payloads be stored against a customer (VP-5537), and the length matches the underlying SQL column.
 * Keeping them in one component stops the three from drifting apart across the forms that capture these names.
 */
const CustomerNameField = (props: Props) => {
	// eslint-disable-next-line react/jsx-props-no-spreading
	return (
		<Text
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...props}
			maxLength={props.maxLength ?? customerNameMaxLength}
			pattern={customerNameRegexString}
			patternMessage={customerNameRegexErrorMessage}
		/>
	);
};

// Matches the CustomerName and PublicDisplayName columns on dbo.Customers.
export const customerNameMaxLength = 100;

type Props = Omit<InputProps, 'pattern' | 'patternMessage'>;

export default CustomerNameField;
